module.exports = __webpack_public_path__ + "static/img/rock@2x.d64291e6.png";